import $ from 'jquery'
import { openMenu, closeMenu, open_menu_state } from '@/function/function.js';
import RecapDMP from '@/views/dossierMedical/dossier-medical/recap-dmp';
import EditDMP from '@/views/dossierMedical/dossier-medical/edit-dmp';

export default {
    name: 'dossier-medical',
    components: {
        RecapDMP, EditDMP
    },
    props: {
        patientId: Number,
        consultation: Object
    },
    data () {
        return {
            is_dmp_edit: false,
            type_dmp: '',

            is_consultation: '',
            l_loading: true,
            
            // -----------------------------------
            vm_state: open_menu_state,
            v:0,

            maladies:'',
            affections_congenitales: null,
            interventions_chirurgicales: null,
            sejours_etranger: null,

            antecedentsPerso:{
                maladies: [],
                affections_congenitales: [],
                sejours_etrangers:[],
                interventions_chirurgicales: [],
                situation_militaire: null,
                pension_invalidite: null,
                observations: null
            },
            antPersoEditMode: false,
            antPerso: false,
            selectedFields: {
                maladies: false,
                interventions_chirurgicales: false,
                situation_militaire: false,
                pension_invalidite: false,
                sejours_etranger: false,
                affections_congenitales: false,
                observations: false
            }
        }
    },
    computed: {
        antecedentsPersonnels(){
            return this.$store.getters['antecedentsPerso']
        },
    },
    mounted () {
        if (this.consultation && this.consultation.id > 0) {
            this.is_consultation = 1
        } else {
            this.is_consultation = 0
        }

        this.$store.dispatch('getPatientAntecedentsPerso',this.patientId).then(
            () =>  {
                this.antecedentsPerso.maladies = this.antecedentsPersonnels.maladies
                this.antecedentsPerso.affections_congenitales = this.antecedentsPersonnels.affections_congenitales
                this.antecedentsPerso.interventions_chirurgicales = this.antecedentsPersonnels.interventions_chirurgicales
                this.antecedentsPerso.sejours_etrangers = this.antecedentsPersonnels.sejours_etrangers
            }
        )
        
        let t = this;
        $(document).bind("click", function(e) {
            let $clicked = $(e.target);
            if (!$clicked.parents().hasClass("option-container")) {
                if(t.v != 0) {
                    t.openMenu(t.v, 'option-box', 'animate-fadeInRight', 'animate-fadeOutRight')
                }
            }
        });
    },
    methods: {
        refreshView(edit_info) {
            this.is_dmp_edit = edit_info.is_edit
            this.type_dmp = edit_info.type_dmp
        },
    
        /**
         * Open Menu Dropdown
         */
         openMenu: function(state, selector, show_in, show_out) 
         {
            this.v = openMenu.dropMenu(state, selector, show_in, show_out)
         },
 
         /**
          * Close Menu Dropdown
          */
         async closeMenu(selector, show_in, show_out) 
         {
            this.v = closeMenu.wrapMenu(selector, show_in, show_out)
         },

        // changeFieldSelectedState: function(data, variable){
        //     eval('this.selectedFields.'+variable+'= !this.selectedFields.'+variable)
            
        // },

        changeEditModeState: function(){
            this.antPersoEditMode = !this.antPersoEditMode
        },

        pushToMaladiesList: function(){
            this.antecedentsPerso.maladies.push(this.maladies)
            this.maladies = null
        
        },

        pushToAffectionsList: function(){
            this.antecedentsPerso.affections_congenitales.push(this.affections_congenitales)
            this.affections_congenitales =null;
        },

        pushToInterventionsChirurgicalesList: function(){
            this.antecedentsPerso.interventions_chirurgicales.push(this.interventions_chirurgicales)
            this.interventions_chirurgicales = null
        },
        pushToSejoursEtrangerList: function(){
            this.antecedentsPerso.sejours_etrangers.push(this.sejours_etranger)
            this.sejours_etranger = null
        },

        removeFromAntecedentsList: function(index,param){
            eval('this.antecedentsPerso.'+param+'.splice('+index+','+1+')')
            //this.antecedentsPerso.maladies.splice(index,1)
        },

        saveAntecedentsPersonnels: function(){

        }
    }
}